import styled, { keyframes } from "styled-components";
import { ParagrafMid } from "../Styled";
import Brian from '../images/brian_profil.png';


export const ProfileInfoCon = styled.div`
background-color: #fefefe;
border-radius: 20px;
position: absolute;
bottom: 0;
left: 0;
right: 0;
padding-bottom: 10px;
box-shadow: 0 -10px 30px rgba(0, 0, 29, 15%);
}
`

export const ProfileName = styled(ParagrafMid)`
color: ${({ theme }) => theme.mainColors.darkblu};
`

export const ProfileTitle = styled(ParagrafMid)`
font-size: 1rem;
line-height: 1.5rem;
`
const open = keyframes`
0% {transform: translateY(100%);
    opacity: 0; max-height: 0px;}
100% {transform: translateY(0);
    opacity: .8; max-height: 400px;}`;

const close = keyframes`
0% {
    opacity: .8; max-height: 400px}
100% {opacity: 0; max-height: 0px}`;

export const ProfileMessage = styled(ParagrafMid)`
font-size: 1rem;
line-height: 1.5rem;
animation-name: ${close};
    animation-duration: 350ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;
`

export const TheCard = styled.div`
display: flex;
flex-direction: column;
width: 250px;
height: 300px;
padding-bottom: 25px;
border-radius: 20px;
position: relative;
background: url(${Brian});
background-repeat: no-reapeat;
background-size: cover;
background-position: 40% -25%;
background-color: #fefefe;
box-shadow: 0 0 30px rgba(0, 0, 29, 15%);
&:hover {
    & ${ProfileMessage} {
        animation-name: ${open};
    animation-duration: 350ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;
    }
}
`